{
    "coordinates": [
        -4.601558255865271,
        -81.26703339531525
    ],
    "tooltip": "Talara",
    "title": "Talara Tar Seeps",
    "country": "Peru",
    "period": "Quaternary",
    "alt": "TODO"
}
